import { TitleCardsList } from "Components/SelectableCard/Title";
import { Flex, Typography } from "antd";

const currentYear = new Date().getFullYear();
const yearOptions = [
  {
    title: `Beginning ${currentYear}`,
  },
  {
    title: `Beginning ${currentYear + 1}`,
  },
  {
    title: `Beginning ${currentYear + 2}`,
  },
];

export const YearApplyingFor = ({ selectedCard, setSelectedCard }) => {
  const { Title } = Typography;
  return (
    <Flex vertical justify="flex-start" align="flex-start">
      <Title style={{ fontSize: "18px", fontWeight: "500" }}>Start year</Title>
      <Flex wrap>
        <TitleCardsList
          options={yearOptions}
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
        />
      </Flex>
    </Flex>
  );
};
